export const roles = {
  USER_ADMIN: "User Admin",
  OPERATOR: "Operator",
  GRADER: "Grader"
};
